"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.using = exports.destroySafe = exports.check = exports.isDestroyable = void 0;
/**
 * Helper function that checks whether a given argument is an object implementing the Destroyable interface.
 *
 * @param x the object
 */
function isDestroyable(d) {
    return (typeof (d) === 'object' && !!d && 'destroyed' in d && 'destroy' in d);
}
exports.isDestroyable = isDestroyable;
/**
 * Helper function that checks whether a Destroyable reference is valid and has not been destroyed.
 *
 * @param d the destroyable
 * @returns {boolean} whether the destroyable can be used (i.e. has not been destroyed).
 */
function check(d) {
    return isDestroyable(d) && !d.destroyed();
}
exports.check = check;
/**
 * Helper function that destroys a Destroyable if the reference is valid and it has not been destroyed.
 *
 * @param d the destroyable
 * @returns {boolean} whether any action was taken
 */
function destroySafe(d) {
    if (check(d)) {
        d.destroy();
        return true;
    }
    return false;
}
exports.destroySafe = destroySafe;
/**
 * Executes the specified callback and destroys the specified Destroyable once the callback has been executed.
 *
 * @param d the destroyable
 * @param callback the callback
 */
function using(d, callback) {
    callback(d);
    if (check(d)) {
        d.destroy();
    }
}
exports.using = using;
